import Text from 'fe-design-base/atoms/Text';

const VerifyCancelInterviewTimesModal = () => (
  <Text
    i18n="hiring.dashboard.v2.set_interview_availability.cancel_modal_text"
    variant="bodySm"
    color="mono700"
  />
);

export default VerifyCancelInterviewTimesModal;
